import { Box } from '@mui/material';

interface StyledBoxProps {
  text: string;
}

export function CustomBox({ text }: StyledBoxProps) {
  return (
    <Box
      sx={{
        bgcolor: '#E0E0E0',
        p: 1,
        borderRadius: '5px', // Bordes redondeados
        textAlign: 'center',
        boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.4)', // Sombra
        fontWeight: 'bold', // Negrita
      }}
    >
      {text}
    </Box>
  );
}
